import { useMutation, useQueryClient } from '@tanstack/react-query';
import { toast } from 'sonner';
import { ActivationPackService } from '@/services/database/ActivationPackService';
import {
  PromoTemplate,
  PromoTemplateType,
  PromoTone,
} from '@/types/activation/activation-pack';

interface GeneratePromoParams {
  packId: string;
  template: PromoTemplateType;
  tone: PromoTone;
  targetUrl: string;
}

export const useGeneratePromo = () => {
  const queryClient = useQueryClient();

  return useMutation<
    { template: PromoTemplateType; tone: PromoTone; content: PromoTemplate } | null,
    Error,
    GeneratePromoParams
  >({
    mutationFn: ({ packId, template, tone, targetUrl }) =>
      ActivationPackService.generatePromo(packId, template, tone, targetUrl),
    onSuccess: (_, { packId }) => {
      queryClient.invalidateQueries({ queryKey: ['activation-pack', packId] });
    },
    onError: (error: Error) => {
      toast.error(error.message || 'Failed to generate copy');
    },
  });
};
